import React from 'react';
import YoutubeThumbnailFallback from './YoutubeThumbnailFallback';
import YoutubeOverlayPlay from './YoutubeOverlayPlay';
import ImageComponentV2 from '../Image/ImageComponentV2';

function YoutubeThumbnail({ className = '', currentVideoId, onFacadeClick }) {
  // Generate YouTube thumbnail URL
  const getThumbnailUrl = (id, quality = 'maxresdefault') => {
    if (!id) return null;
    return `https://img.youtube.com/vi/${id}/${quality}.jpg`;
  };

  // Show facade (lightweight thumbnail + play button)
  const thumbnailUrl = getThumbnailUrl(currentVideoId);

  // Handle keyboard accessibility
  const handleKeyPress = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onFacadeClick();
    }
  };

  return (
    <div
      className={`relative cursor-pointer group ${className}`}
      onClick={onFacadeClick}
      onKeyPress={handleKeyPress}
      tabIndex={0}
      role="button"
      aria-label={`Play YouTube video ${currentVideoId || ''}`}
    >
      {/* YouTube thumbnail */}
      {thumbnailUrl && (
        // <img
        //   src={thumbnailUrl}
        //   alt="Youtube video thumbnail"
        //   className="w-full h-full object-contain object-center absolute inset-0"
        //   loading="lazy"
        //   onError={(e) => {
        //     // Fallback to lower quality thumbnail
        //     e.target.src = getThumbnailUrl(currentVideoId, 'hqdefault');
        //   }}
        // />

        <ImageComponentV2
          src={thumbnailUrl}
          alt="Youtube video thumbnail"
          className="w-full h-full object-contain object-center absolute inset-0"
          loading="lazy"
          onError={(e) => {
            // Fallback to lower quality thumbnail
            e.target.src = getThumbnailUrl(currentVideoId, 'hqdefault');
          }}
        />
      )}

      {/* Fallback background for missing thumbnails */}
      {!thumbnailUrl && <YoutubeThumbnailFallback />}

      {/* Play button overlay including branding */}
      <YoutubeOverlayPlay />
    </div>
  );
}

export default YoutubeThumbnail;
